module.exports = "<p>\n  pnel-sessions works!\n</p>\n"